"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("BasisModal", {
    attrs: {
      footer: _vm.validFormulaList.length === 0 ? null : undefined,
      title: "选择已有公式"
    },
    on: {
      ok: _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.validFormulaList.length === 0 ? [_c("a-empty", {
    staticClass: "m-m-t-64",
    attrs: {
      description: "当前模板暂无可用的公式科目"
    }
  })] : _c("a-radio-group", {
    model: {
      value: _vm.selectedFormulaId,
      callback: function ($$v) {
        _vm.selectedFormulaId = $$v;
      },
      expression: "selectedFormulaId"
    }
  }, [_c("div", {
    staticClass: "m-m-b-8"
  }, [_vm._v("“等号"), _c("span", {
    staticClass: "m-type-warning"
  }, [_vm._v("=")]), _vm._v("右侧”部分将被填充到当前公式中，请选择公式并点击右下角的“确定”按钮进行快捷填充。")]), _c("a-radio", {
    staticClass: "m-m-b-8",
    attrs: {
      disabled: ""
    }
  }, [_c("div", {
    staticStyle: {
      display: "inline-flex"
    }
  }, [_c("span", {
    staticClass: "m-tips-color",
    staticStyle: {
      width: "120px",
      "flex-shrink": "0",
      "white-space": "normal"
    }
  }, [_vm._v("此处为科目名称")]), _c("span", {
    staticClass: "m-type-warning m-m-l-4 m-m-r-4"
  }, [_vm._v("=")]), _c("span", {
    staticClass: "m-type-primary",
    staticStyle: {
      "white-space": "normal"
    }
  }, [_vm._v("此处为公式具体值")])])]), _vm._l(_vm.validFormulaList, function (formula, formulaIndex) {
    return _c("div", {
      key: formulaIndex,
      staticClass: "m-border-bottom formula-item"
    }, [_c("a-radio", {
      attrs: {
        value: formula.id
      }
    }, [_c("div", {
      staticStyle: {
        display: "inline-flex"
      }
    }, [_c("span", {
      staticClass: "m-tips-color",
      staticStyle: {
        width: "120px",
        "flex-shrink": "0",
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(formula.name))]), _c("span", {
      staticClass: "m-type-warning m-m-l-4 m-m-r-4"
    }, [_vm._v("=")]), _c("span", {
      staticStyle: {
        "white-space": "normal"
      }
    }, _vm._l(formula.formulaRules, function (item, index) {
      return _c("span", {
        key: index,
        class: _vm.getItemClass(item)
      }, [_vm._v(_vm._s(item.label.toString().replace(/\#\{/g, "【").replace(/\}/g, "】")))]);
    }), 0)])])], 1);
  })], 2)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;